<template>
  <div class="beltMonitor" ref="beltMonitor">
    <div class="tltle">
      <div class="home_number" v-if="styleType == 'typeDark'">{{ options.length }}</div>
      <el-select v-model="value" filterable placeholder="请选择" @change="change()">
        <el-option
          v-for="(item, i) in options"
          :key="i"
          :label="item.deviceName"
          :value="item.deviceNo"
        >
        </el-option>
      </el-select>
    </div>
    <div class="chartImg" @click="goToPopup()">
      <div class="chart" ref="chart"></div>
      <div class="msg_box">
        <div class="msg_txt">
          <p class="msg_p">
            <span class="msg_time"><span class="point"></span>小时监测</span>
          </p>
        </div>
        <div class="msg_img">
          <img v-if="imgUrl" :src="imgUrl" alt="" />
          <img v-else src="./img/noData.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapGetters } from "vuex";
import getOpt from "./beltMonitorOpt.js";
import { unwarp } from "@/utils/tools.js";
import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';
import iframePup from "@/modules/iframePup/iframePup.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'beltMonitor.vue',
      computedName: '皮带通廊监控组件',
      styleType: "",
      customerId: this.$store.state.customerId,
      chart: null,
      options: [],
      value: "",
      imgUrl: "",
      time: "",
      setTime1: null,
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  //监控data中的数据变化
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
        this.typeChange();
      },
      deep: true,
    },
  },
  created() {
    this.styleType = this.$store.state.styleType;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.beltMonitor).outerWidth();
    let h = $(that.$refs.beltMonitor).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });

    this.getList();
    // this.getData();
    this.typeChange();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  //方法集合
  methods: {
    typeChange() {
      if (this.styleType == "typeGreen") {
        this.$nextTick(() => {
          $(".beltMonitor .tltle").css({
            "padding-top": "20px",
            height: "25px",
          });
          $(".beltMonitor .chartImg").css({
            "margin-top": "20px",
            height: "175px",
          });
        });
      } else if (this.styleType == "typeDark") {
        this.$nextTick(() => {
          $(".beltMonitor .tltle").css({
            "padding-top": "initial",
            height: "24px",
          });
          $(".beltMonitor .chartImg").css({
            "margin-top": "initial",
            height: "185px",
          });
        });
      }
    },
    async getList() {
      let selectVdmDeviceList = CONFIG.requestName + this.$apiOpt.selectVdmDeviceList;
      let data = await this.$apiUtils.get(selectVdmDeviceList, {
        customerId: this.customerId,
        typeId: 1539730750575003,
      });
      if (this.customerId == 46) {
        let tmpData = $.extend(true, [], data);
        let tmpFst = tmpData.shift();
        tmpData.push(tmpFst);
        this.options = tmpData;
        if (tmpData.length) {
          this.value = tmpData[0].deviceNo;
        }
      } else {
        this.options = data;
        if (data.length) {
          this.value = data[0].deviceNo;
        }
      }
      this.change();
    },
    async change() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      let that = this;
      this.imgUrl = "";
      let findVdmOneHundred = CONFIG.requestName + this.$apiOpt.findVdmOneHundred;
      let data = await this.$apiUtils.get(findVdmOneHundred, {
        customerId: this.customerId,
        deviceNo: this.value,
        typeId: 1539730750575003,
      });
      if (data) {
        if (data.vdmImgList.length) {
          this.imgUrl = data.vdmImgList[0].imgUrl;
          this.time = data.vdmImgList[0].collectionTime;
        }
        let xList = [],
          yList = [];
        data.signalDetailList.forEach((item) => {
          xList.push(item.dateTime);
          yList.push(item.value);
        });
        let aa = { dateTime: "", value: "" };
        if (that.time) {
          for (var i = 0; i < data.signalDetailList.length; i++) {
            if (
              that.time < data.signalDetailList[i].dateTime &&
              that.time > data.signalDetailList[i - 1].dateTime
            ) {
              aa.dateTime = data.signalDetailList[i].dateTime;
              aa.value = data.signalDetailList[i].value;
            } else if (this.time < data.signalDetailList[0].dateTime) {
              aa.dateTime = data.signalDetailList[0].dateTime;
              aa.value = data.signalDetailList[0].value;
            } else if (
              this.time > data.signalDetailList[data.signalDetailList.length - 1].dateTime
            ) {
              aa.dateTime =
                data.signalDetailList[data.signalDetailList.length - 1].dateTime;
              aa.value = data.signalDetailList[data.signalDetailList.length - 1].value;
            }
          }
        }
        let xyData = {
          xData: xList,
          yData: yList,
        };
        if (!this.chart) {
          this.chart = echarts.init(this.$refs.chart);
          this.$forceUpdate();
        } else {
          this.chart.dispose();
          this.chart = null;
        }
        this.chart = echarts.init(this.$refs.chart);
        unwarp(this.chart).setOption(getOpt(xyData, aa));
      }
      this.setTime1 = setTimeout(() => {
        this.change();
      }, 60 * 1000 * 5);
    },

    async goToPopup() {
      this.$store.commit("dialogStatus", true);
      let baseUrl = window.bmeConfig.baseUrlHttp;
      this.$popup.open(iframePup, this.dialogCompontent, this, {
        dialog: `${baseUrl}/standard/${window.CONFIG.requestName}/page/govern/vdm_stand.html?customerId=${this.customerId}&deviceNo=${this.value}&typeId=1539730750575003&style=${this.styleType}` + (window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
      });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
.beltMonitor {
  width: 600px;
  height: 250px;
  .tltle {
    display: flex;
    justify-content: flex-end;
    height: 24px;
    .home_number {
      margin-right: 140px;
    }
  }
  .chartImg {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    height: 185px;
    padding-top: 10px;
    .chart {
      width: 50%;
      height: 100%;
    }
    .msg_box {
      width: 50%;
      height: 100%;
      padding-top: 30px;
      position: relative;
      .msg_txt {
        position: absolute;
        left: 0px;
        top: 0px;
        .msg_p {
          margin-top: 5px;
          display: flex;
          .msg_time {
            font-size: 14px;
            text-align: right;
            display: block;
            height: 14px;
            line-height: 14px;
            color: #f4c48f;
            .point {
              display: inline-block;
              width: 8px;
              height: 8px;
              background: #ffffff;
              box-shadow: 0px 0px 4px 0px #9fbafd;
              border: 1px solid #9fbafd;
              border-radius: 50%;
              margin-right: 8px;
            }
          }
        }
      }
      .msg_img {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

}
</style>
<style scoped>
.beltMonitor .el-select {
  width: 240px;
}
.beltMonitor /deep/ .el-select .select-trigger .el-input .el-input__suffix-inner {
  display: flex;
}
.beltMonitor /deep/ .el-select .select-trigger .el-input .el-input__suffix-inner .el-icon-arrow-up {
  line-height: 26px;
}
</style>
